<script setup>
import { computed } from 'vue';
import { useSubscriptionStore } from '@organisms/ubiq-administration/store/subscriptions';
import { URL_ADDRESS_PAGE, URL_OFFER_VIEW_ENDPOINT } from '@tools/routes/routes';
import { trans } from '../../../../_00_elements/translation';
import SubscriptionDetailsSection from './SubscriptionDetailsSection.vue';
import SubscriptionDetailsValue from './SubscriptionDetailsValue.vue';

const subscriptionData = computed(() => useSubscriptionStore().selectedSubscriptionData);
</script>

<template>
  <SubscriptionDetailsSection>
    <template #details>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.office_space')" class="subscription-details-section__offers">
        <a :href="`${URL_ADDRESS_PAGE}/${subscriptionData?.address.id}`" target="_blank">
          {{ subscriptionData?.address.name }}
        </a>
      </SubscriptionDetailsValue>
      <SubscriptionDetailsValue :label="trans('gestion.subscription.offices')" class="subscription-details-section__offers">
        <div v-for="(office, index) in subscriptionData?.office_offers" :key="index">
          <a :href="`${URL_OFFER_VIEW_ENDPOINT}/${office.hash_id}`" target="_blank">{{ office.name }}</a>
          {{ index < (subscriptionData?.office_offers.length - 1) ? trans('global.plus') : '' }}
        </div>
      </SubscriptionDetailsValue>
    </template>
  </SubscriptionDetailsSection>
</template>
